import { Link } from "iconoir-react";

import { createIcon } from "../create-icon";

export const IconLink12Line = createIcon(Link, 12, "Line");
export const IconLink16Line = createIcon(Link, 16, "Line");
export const IconLink20Line = createIcon(Link, 20, "Line");
export const IconLink24Line = createIcon(Link, 24, "Line");
export const IconLink32Line = createIcon(Link, 32, "Line");
export const IconLink48Line = createIcon(Link, 48, "Line");
export const IconLink64Line = createIcon(Link, 64, "Line");
